var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "  row color_light",
    staticStyle: {}
  }, [_c('div', {
    staticClass: "col-md-8",
    staticStyle: {
      "padding": "3px 3px"
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.$t('packingb2b.packingBoxId')) + ":  "), _c('span', {
    staticClass: "textcolor"
  }, [_vm._v("  " + _vm._s(_vm.boxdata.boxid) + " ")])]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.$t('orders.totalQTY')) + ": "), _c('span', {
    staticClass: "textcolor"
  }, [_vm._v("  " + _vm._s(_vm.boxdata.qty))])]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.$t('boxList.boxWeight')) + ":"), _c('span', {
    staticClass: "textcolor"
  }, [_vm._v("  " + _vm._s(_vm.boxdata.weight))])]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.$t('packingb2b.boxDimension')) + ":"), _c('span', {
    staticClass: "textcolor"
  }, [_vm._v("  " + _vm._s(_vm.boxdata.lbh))])])]), _vm._v(" "), _c('div', {
    staticClass: " col-md-4",
    staticStyle: {
      "padding": "3px 0px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary shipinvoice",
    staticStyle: {
      "width": "100%",
      "margin-bottom": "5px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.selectType(1)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('packingb2b.shipLabel')) + "\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary shipinvoice",
    staticStyle: {
      "width": "100%",
      "float": "right"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.selectType(0)
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('packingb2b.packingList')) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 mb-1"
  }), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "confirmationmodal",
      "title": "Confirmation",
      "data-backdrop": "static"
    },
    model: {
      value: (_vm.modalShowForConfirmType),
      callback: function($$v) {
        _vm.modalShowForConfirmType = $$v
      },
      expression: "modalShowForConfirmType"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h6', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('packingb2b.printPackingSlip')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "confirmationmodal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.modalShowForConfirm
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.papertype),
      expression: "papertype"
    }],
    staticClass: "col-lg-1",
    attrs: {
      "type": "radio",
      "id": "paper",
      "name": "pickingtype",
      "value": "paper"
    },
    domProps: {
      "checked": _vm._q(_vm.papertype, "paper")
    },
    on: {
      "__c": function($event) {
        _vm.papertype = "paper"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "cluster"
    }
  }, [_vm._v(_vm._s(_vm.$t('packingb2b.paper')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.papertype),
      expression: "papertype"
    }],
    staticClass: "col-lg-1",
    attrs: {
      "type": "radio",
      "id": "sticker",
      "name": "pickingtype",
      "value": "sticker"
    },
    domProps: {
      "checked": _vm._q(_vm.papertype, "sticker")
    },
    on: {
      "__c": function($event) {
        _vm.papertype = "sticker"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "batch"
    }
  }, [_vm._v(_vm._s(_vm.$t('packingb2b.sticker')))]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "float-right"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.downloadShipLabel
    }
  }, [_vm._v(_vm._s(_vm.$t('common.print')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.modalShowForConfirm
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(_vm._s(_vm.$t('common.cancelBtn')))])])])])])])])])], 1)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3446269c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3446269c","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/common_components/singlepackingbox.vue
// module id = 2084
// module chunks = 0